(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/start/assets/react/components/start-video.js') >= 0) return;  svs.modules.push('/modules/lotto/components/start/assets/react/components/start-video.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useRef = _React.useRef,
  useState = _React.useState;
const useVideoFormat = svs.lotto.react.hooks.useVideoFormat;
const cmsVideos = svs.lotto.data.cms_videos;
const StartVideo = () => {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    videoUrl = _useState4[0],
    setVideoUrl = _useState4[1];
  const _useVideoFormat = useVideoFormat(),
    format = _useVideoFormat.format,
    mime = _useVideoFormat.mime,
    codecs = _useVideoFormat.codecs;
  const videoRef = useRef(null);

  useEffect(() => {
    if (format === null || !cmsVideos) {
      svs.numbergames.game.animations.lotto.startFadeInText();
    }
  }, [format]);

  useEffect(() => {
    if (!format || !cmsVideos) {
      return;
    }
    const matched = cmsVideos.find(v => {
      var _v$documentMime;
      return (_v$documentMime = v.documentMime) === null || _v$documentMime === void 0 ? void 0 : _v$documentMime.includes(format);
    });
    if (matched) {
      var _svs;
      const cdnUrl = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 ? void 0 : _svs.cdn2;
      setVideoUrl("https:".concat(cdnUrl).concat(matched.documentUrl));
    } else {
      setError(true);
    }
  }, [format]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !videoUrl) {
      return;
    }
    video.load();
    const play = video.play();
    if (play && typeof play.catch === 'function') {
      play.catch(() => {
        setError(true);
      });
    }
    const isVideoPlaying = () => video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
    const checkTimeout = setTimeout(() => {
      if (!isVideoPlaying()) {
        setError(true);
      }
    }, 1000);
    return () => clearTimeout(checkTimeout);
  }, [videoUrl]);
  const handlePlay = () => {
    svs.numbergames.game.animations.lotto.startFadeInText();
  };

  useEffect(() => {
    if (error) {
      svs.numbergames.game.animations.lotto.startFadeInText();
    }
  }, [error]);
  const source = useMemo(() => {
    if (!format || !videoUrl) {
      return null;
    }
    return React.createElement("source", {
      onError: () => setError(true),
      src: videoUrl,
      type: "".concat(mime, "; codecs=\"").concat(codecs, "\"")
    });
  }, [format, videoUrl, mime, codecs]);
  if (error || !source) {
    return null;
  }
  return React.createElement("div", {
    className: "start-video"
  }, React.createElement("video", {
    autoPlay: true,
    muted: true,
    onError: () => {
      svs.lotto.logger.debug('Startpage: Video playback error');
      setError(true);
    },
    onPlay: handlePlay,
    playsInline: true,
    ref: videoRef
  }, source));
};
setGlobal('svs.lotto.react.components', {
  StartVideo
});

 })(window);